import { openDB } from 'idb';

import { IDB_NAME, TOPICS_IDB, TOPICS_IMAGES_IDB } from '@/constants/IndexedDB';

export const getTopicFromIDB = async topicId => {
  const db = await openDB(IDB_NAME);
  if (!db) return;

  const tx = db.transaction(TOPICS_IDB, 'readwrite');
  const store = tx.objectStore(TOPICS_IDB);

  const topic = await store.get(Number(topicId));
  await tx.done;

  return topic;
};
